import {useCallback} from 'react';
import {useFramework} from '@/hooks';

export const useApiWithRegion = (api: (...params: any) => Promise<any>) => {
    const {region: {currentRegion}} = useFramework();
    return useCallback(
        (...arg) => api(...arg, currentRegion),
        [api, currentRegion]
    );
};
